import React from "react";
import get from "lodash/get";
import { object } from "prop-types";

import StarRating from "../../../atoms/icons/star-rating";

import "./movie-rating.m.css";

const MovieRating = ({ metadata }) => {
  if (!metadata) return null;

  const stars = ["blank-star", "blank-star", "blank-star", "blank-star", "blank-star"];
  const movieName = get(metadata, ["story-attributes", "movie", "0", "name"]);
  const rating = get(metadata, ["review-rating", "value"], "0");

  if (Number(rating) % 1 === 0) {
    stars.fill("full-star", 0, Number(rating));
  } else {
    const splitedRating = rating.split(".");
    const fullStarNumber = Number(splitedRating[0]);
    stars.fill("full-star", 0, fullStarNumber);
    stars.fill("half-star", fullStarNumber, fullStarNumber + 1);
  }

  return (
    <div styleName="wrapper">
      <div styleName="movie">
        <h3 styleName="movie-name">{movieName}</h3>
        <h2 styleName="comment" dangerouslySetInnerHTML={{ __html: metadata["review-title"] }} />
      </div>
      <div styleName="rating">
        {stars.map((star, index) => (
          <StarRating star={star} index={index} key={index} />
        ))}
      </div>
    </div>
  );
};

MovieRating.propTypes = {
  metadata: object,
};

export default MovieRating;
